/* export const dateSorter = (a, b) => {
    const dateA = new Date(a.goTrashDate.replace(/(\d{4})\/(\d{2})\/(\d{2})/, '$2/$3/$1'));
    const dateB = new Date(b.goTrashDate.replace(/(\d{4})\/(\d{2})\/(\d{2})/, '$2/$3/$1'));
  
    return dateA.getTime() - dateB.getTime();
  }; */
  export function dateSorter(date1, date2) {
    const parsedDate1 = new Date(date1.goTrashDate);
    const parsedDate2 = new Date(date2.goTrashDate);
  
    if (parsedDate1 < parsedDate2) {
      return -1;
    } else if (parsedDate1 > parsedDate2) {
      return 1;
    } else {
      return 0;
    }
  }
  /** Se muestra cuando la fila no tiene una fecha de eliminación conocida. */
  export const NO_DATE = '\u2014';

  /**
   * Formatea una fecha para la papelera.
   *
   * El guardia de null/'' no es defensivo de más: `new Date(null)` NO es una
   * fecha inválida, es epoch 0, y en America/Santiago (UTC-3) eso se renderiza
   * como 1969/12/31 — que es exactamente lo que la papelera mostraba en
   * producción para los objetos sin goTrashDate.
   */
  export function convertDateString(dateString) {
    // Cubre null, undefined, '' y 0. El 0 entra a propósito: como timestamp es
    // epoch, la misma fecha de 1969 por otra vía, y no un dato real del dominio.
    if (!dateString) {
      return NO_DATE;
    }

    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return NO_DATE;
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
  
    const formattedDate = `${year}/${month}/${day}`;
    return formattedDate;
  }
  